<template>
  <b-modal
    id="viewconfigs"
    class="testconfigmodal"
    centered
    hide-footer
    hide-header
    size="xl"
    :visible="showModal"
    @show="getAllConfigs"
    no-close-on-backdrop
    @hidden="closeViewConfig"
  >
    <b-overlay :show="showSpinner" rounded="sm">
      <div class="d-flex justify-content-between align-items-center">
        <div class="modal-heading">Select Configuration</div>
        <div
          @click="closeViewConfig"
          class="xmark-modal-pos rotate-on-hover pointer"
        >
          <img src="../../../assets/panelist/blue_cross.svg" alt="" />
        </div>
      </div>
      <hr class="vc-hr" />
      <div class="d-flex justify-content-between mt-3 pt-3 px-2">
        <div class="search-bar w-75 mr-3">
          <img
            class="search-pos"
            src="../../../assets/img/search-bar-icon.svg"
            alt=""
          />
          <b-form-input
            class="search-input w-75"
            type="search"
            placeholder="Search Configuration"
            v-model="searchConfig"
            debounce="500"
            @update="getAllConfigs"
          ></b-form-input>
        </div>

        <div class="d-flex align-items-center relativeclass bluebtn">
          <div class="relativeclass">
            <div>
              <b-button
                ref="filterbox2"
                class="acs-addBtn-modal mr-2 pointer"
                @click="showFilterBox = !showFilterBox"
              >
                <img
                  src="../../../assets/img/accessconnew/whiteFilter.svg"
                  alt=""
                  class="mr-2"
                />

                <span class="">Filter</span>
              </b-button>
            </div>
            <div
              id="filtermodal"
              v-show="showFilterBox"
              :class="
                selectedConfiguration != null &&
                Object.keys(selectedConfiguration).length != 0
                  ? 'group-filter-modal-selected'
                  : 'group-filter-modal'
              "
              ref="filterbox"
              v-closable="{
                exclude: ['filterbox', 'filterbox2'],
                handler: 'hidefilterbox',
              }"
            >
              <div class="qb-fm-heading">Configure Type:</div>
              <SelectDropdown
                :type="'filter'"
                :dropdownOptions="testoptions"
                :showError="false"
                :value="selectOptions.value"
                :placeholder="'Select'"
                @setValue="selectDpd"
              />
              <div
                class="d-flex align-items-center justify-content-between mt-3"
              >
                <div class="reset-btn">
                  <b-button class="" @click="showFilterBox = false">
                    Cancel
                  </b-button>
                </div>
                <div class="d-flex">
                  <div class="reset-btn">
                    <b-button
                      :disabled="selectOptions.value == ''"
                      @click="clearfilter()"
                    >
                      Reset
                    </b-button>
                  </div>
                  <div class="reset-btn ml-2">
                    <b-button
                      :disabled="selectOptions.value == ''"
                      @click="applyFilter()"
                    >
                      Apply
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bluebtn">
            <b-button class="acs-addBtn-modal" @click="createNewConfig">
              <img
                src="../../../assets/panelist/plus_pan.svg"
                alt=""
                class="mr-2"
              />

              <span class="">Configuration</span>
            </b-button>
          </div>
        </div>
      </div>

      <div>
        <div
          class="mt-4"
          v-if="
            selectedConfiguration != null &&
            Object.keys(selectedConfiguration).length != 0
          "
        >
          <div class="relativeclass">
            <div class="select-config-head">
              <div class="select-config-head-font">Selected Configuration</div>
            </div>
            <div class="d-flex select-configurations">
              <div style="width: 90%" class="d-flex align-items-center">
                <div class="selectedColorbar ml-1"></div>
                <div class="d-flex align-items-center py-3 w-100">
                  <div class="ml-4">
                    <div class="allocateradios pr-3">
                      <b-form-radio
                        v-model="selectedRow.configID"
                        :value="selectedRow.configID"
                        :checked="isSelected(selectedConfiguration)"
                      ></b-form-radio>
                    </div>
                  </div>
                  <div style="width: 20%">
                    <div class="select-configurations-head">
                      Configuration Name
                    </div>
                    <div
                      v-b-popover.hover.bottom="
                        selectedConfiguration.configName
                      "
                      class="
                        select-configurations-subhead
                        mt-2
                        mr-5
                        text-truncate
                      "
                    >
                      {{ selectedConfiguration.configName }}
                    </div>
                  </div>
                  <div style="width: 30%">
                    <div class="select-configurations-head">Test Organiser</div>
                    <div class="select-configurations-subhead mt-2">
                      {{ selectedConfiguration.config.testOrg }}
                    </div>
                  </div>
                  <div style="width: 25%">
                    <div class="select-configurations-head">Type</div>
                    <div class="select-configurations-subhead mt-2">
                      {{ selectedConfiguration.config.test }}
                    </div>
                  </div>
                  <div style="width: 15%">
                    <div class="select-configurations-head">
                      Max No Of Attempts
                    </div>
                    <div class="select-configurations-subhead mt-2">
                      {{ selectedConfiguration.config.maxnoattempts }}
                    </div>
                  </div>
                </div>
              </div>

              <div
                style="width: 10%"
                class="d-flex align-items-center justify-content-center"
              >
                <img
                  v-b-popover.hover.top="'View'"
                  @click.stop="viewConfig(selectedConfiguration)"
                  src="../../../assets/img/accessconnew/blueEye.svg"
                  alt=""
                  class="mr-3 pointer"
                />
                <img
                  v-b-popover.hover.top="'Edit'"
                  src="../../../assets/panelist/blue_pencil.svg"
                  alt=""
                  class="mr-3 ml-2 pointer"
                  @click.stop="editConfig(selectedConfiguration)"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="relativeclass mt-3 pl-2">
          <!-- table starts -->
          <div class="table-main">
            <table
              aria-describedby="tableDescription"
              class="w-100 tp-reports-vc-table"
            >
              <thead>
                <tr>
                  <th
                    id="tableDescription"
                    style="width: 5%"
                    class="text-left pl-3"
                  ></th>
                  <th
                    id="tableDescription"
                    style="width: 20%"
                    class="text-left pr-4"
                  >
                    <span>Name</span>
                    <template v-if="filterColumnConfig == 'configName'">
                      <img
                        v-show="enableConfigFilter"
                        class="pointer ml-1 img-h"
                        src="../../../assets/panelist/up_sort.svg"
                        alt=""
                        @click="filterByDesc('configName')"
                      />
                      <img
                        v-show="!enableConfigFilter"
                        class="pointer ml-1 img-h"
                        src="../../../assets/panelist/down_sort.svg"
                        alt=""
                        @click="filterByAsc('configName')"
                      />
                    </template>
                    <img
                      v-else
                      class="pointer ml-1 img-h"
                      src="../../../assets/panelist/no_sort.svg"
                      alt=""
                      @click="
                        filterByAsc('configName'), (enableConfigFilter = true)
                      "
                    />
                  </th>

                  <th style="width: 15%" class="text-left">
                    <span>Test Organiser</span>
                    <template v-if="filterColumnConfig == 'testOrg'">
                      <img
                        v-show="enableConfigFilter"
                        class="pointer ml-1 img-h"
                        src="../../../assets/panelist/up_sort.svg"
                        alt=""
                        @click="filterByDesc('testOrg')"
                      />
                      <img
                        v-show="!enableConfigFilter"
                        class="pointer ml-1 img-h"
                        src="../../../assets/panelist/down_sort.svg"
                        alt=""
                        @click="filterByAsc('testOrg')"
                      />
                    </template>
                    <img
                      v-else
                      class="pointer ml-1 img-h"
                      src="../../../assets/panelist/no_sort.svg"
                      alt=""
                      @click="
                        filterByAsc('testOrg'), (enableConfigFilter = true)
                      "
                    />
                  </th>
                  <th style="width: 15%" class="text-left">
                    <span>Type</span>
                    <template v-if="filterColumnConfig == 'test'">
                      <img
                        v-show="enableConfigFilter"
                        class="pointer ml-1 img-h"
                        src="../../../assets/panelist/up_sort.svg"
                        alt=""
                        @click="filterByDesc('test')"
                      />
                      <img
                        v-show="!enableConfigFilter"
                        class="pointer ml-1 img-h"
                        src="../../../assets/panelist/down_sort.svg"
                        alt=""
                        @click="filterByAsc('test')"
                      />
                    </template>
                    <img
                      v-else
                      class="pointer ml-1 img-h"
                      src="../../../assets/panelist/no_sort.svg"
                      alt=""
                      @click="filterByAsc('test'), (enableConfigFilter = true)"
                    />
                  </th>
                  <th style="width: 20%" class="text-left">
                    <span>Max No of Attempts</span>
                    <template v-if="filterColumnConfig == 'maxnoattempts'">
                      <img
                        v-show="enableConfigFilter"
                        class="pointer ml-1 img-h"
                        src="../../../assets/panelist/up_sort.svg"
                        alt=""
                        @click="filterByDesc('maxnoattempts')"
                      />
                      <img
                        v-show="!enableConfigFilter"
                        class="pointer ml-1 img-h"
                        src="../../../assets/panelist/down_sort.svg"
                        alt=""
                        @click="filterByAsc('maxnoattempts')"
                      />
                    </template>
                    <img
                      v-else
                      class="pointer ml-1 img-h"
                      src="../../../assets/panelist/no_sort.svg"
                      alt=""
                      @click="
                        filterByAsc('maxnoattempts'),
                          (enableConfigFilter = true)
                      "
                    />
                  </th>

                  <th style="width: 10%" class="text-left pr-3">
                    <span>Status</span>
                    <template v-if="filterColumnConfig == 'open'">
                      <img
                        v-show="enableConfigFilter"
                        class="pointer ml-1 img-h"
                        src="../../../assets/panelist/up_sort.svg"
                        alt=""
                        @click="filterByDesc('open')"
                      />
                      <img
                        v-show="!enableConfigFilter"
                        class="pointer ml-1 img-h"
                        src="../../../assets/panelist/down_sort.svg"
                        alt=""
                        @click="filterByAsc('open')"
                      />
                    </template>
                    <img
                      v-else
                      class="pointer ml-1 img-h"
                      src="../../../assets/panelist/no_sort.svg"
                      alt=""
                      @click="filterByAsc('open'), (enableConfigFilter = true)"
                    />
                  </th>
                  <th style="width: 15%" class="text-left">
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-center
                        relativeclass
                        ml-3
                        pl-3
                      "
                    >
                      Actions
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody
                id="config"
                :style="
                  selectedConfiguration != null &&
                  Object.keys(selectedConfiguration).length != 0
                    ? 'height: calc(100vh - 433px)'
                    : 'height: calc(100vh - 337px)'
                "
              >
                <template v-if="configurations.length > 0">
                  <tr v-for="(config, index) in configurations" :key="index">
                    <td style="width: 5%" class="text-left pl-3">
                      <div class="gridgreencolorDynamic-user"></div>
                      <div class="allocateradios">
                        <b-form-radio
                          class="pointer"
                          v-model="selectedRow.configID"
                          :value="config.configID"
                          :checked="isSelected(config)"
                          @change="configAssign(config)"
                        ></b-form-radio>
                      </div>
                    </td>
                    <td style="width: 20%" class="text-left pr-4">
                      <span
                        v-b-tooltip.hover.top="config.configName"
                        class="text-truncate"
                        >{{ config.configName }}</span
                      >
                    </td>

                    <td style="width: 15%" class="text-left">
                      {{ config.config.testOrg }}
                    </td>
                    <td style="width: 15%" class="text-left">
                      {{ config.config.test }}
                    </td>
                    <td style="width: 20%" class="text-left">
                      {{ config.config.maxnoattempts }}
                    </td>
                    <td style="width: 10%" class="text-left">
                      <span v-if="config.open === 'False'" class="expired-text"
                        >Expired</span
                      >
                      <span v-else class="active-text">Active</span>
                    </td>
                    <td style="width: 15%" class="text-right">
                      <img
                        v-b-popover.hover.top="'View'"
                        @click.stop="viewConfig(config)"
                        src="../../../assets/img/accessconnew/blueEye.svg"
                        alt=""
                        class="mr-3 pointer"
                      />
                      <img
                        v-b-popover.hover.top="'Edit'"
                        src="../../../assets/panelist/blue_pencil.svg"
                        alt=""
                        class="mr-3 pointer"
                        @click.stop="editConfig(config)"
                      />
                    </td>
                  </tr>
                </template>

                <template v-else>
                  <tr class="selected-table-cards">
                    <td class="text-center">No configuration found</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div
            class="
              acs-paginaTion-new
              d-flex
              justify-content-between
              align-items-center
            "
          >
            <div class="d-flex">
              <span class="acs-gotopage-text p-1 mr-2">Go to page</span>
              <b-form-input
                type="text"
                class="acs-pagination-num"
                v-model="goToPage"
                @keyup.enter="
                  goToPage === null || goToPage == '' || iscontainsNumber
                    ? ''
                    : gotopgnum(goToPage)
                "
                @keypress="NumbersOnly"
              ></b-form-input>
              <span
                class="acs-pagination-addbtn"
                :class="
                  goToPage === null || goToPage == '' || iscontainsNumber
                    ? 'disableDeleteIcon pl-3 mt-1'
                    : 'pointer pl-3 mt-1'
                "
                @click="gotopgnum(goToPage)"
                :disabled="
                  goToPage === null || goToPage == '' || iscontainsNumber
                "
              >
                <span
                  ><img src="../../../assets/panelist/page_arrow.svg" alt=""
                /></span>
              </span>
            </div>

            <div class="pagination">
              <b-pagination
                align="center"
                first-number
                last-number
                v-model="currentPage"
                :total-rows="total"
                :per-page="configCount"
                @input="getAllConfigs"
              >
                <template #prev-text
                  ><span
                    ><img
                      src="../../../assets/img/accessconnew/pageleft.svg"
                      alt=""
                    /> </span
                ></template>
                <template #next-text
                  ><span
                    ><img
                      src="../../../assets/img/accessconnew/pageright.svg"
                      alt="" /></span
                ></template>
              </b-pagination>
            </div>
            <div class="d-flex align-items-center">
              <PageInput :pagecount="configCount" @update-value="updatePage" />
              <div
                class="acs-gotopage-text mr-2 ml-4 d-flex justify-content-end"
              >
                Showing :
                <div
                  class="text-truncate ml-2 results-individual-width"
                  v-if="pageStart > total"
                >
                  0
                </div>
                <div v-else class="text-truncate ml-2 results-individual-width">
                  {{ pageStart }}
                </div>
                <div class="text-truncate ml-2 results-individual-width">-</div>
                <div class="text-truncate ml-2 results-individual-width">
                  {{ pageEnd }}
                </div>
                <div class="text-truncate ml-2 results-individual-width">
                  &nbsp;Of
                </div>
                <div class="text-truncate ml-2 results-individual-width">
                  &nbsp;{{ total }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="
              d-flex
              align-items-center
              justify-content-end
              w-100
              bluebtn
              mt-2
            "
          >
            <b-button class="acs-cancelBtn-modal mr-3" @click="closeViewConfig"
              >Cancel</b-button
            >
            <b-button
              class="acs-addBtn-modal"
              @click="selectConfig"
              :disabled="selectedConfig === null"
            >
              Select Configuration
            </b-button>
          </div>
        </div>
      </div>
      <b-modal
        id="confirm-config"
        centered
        hide-footer
        hide-header
        class="qb-add-ques-modal"
        @hidden="$bvModal.hide('confirm-config')"
      >
        <div
          class="modalheading d-flex align-items-center justify-content-between"
        >
          Caution !
        </div>
        <div @click="$bvModal.hide('confirm-config')" class="xMarkCancel">
          <img src="../../../assets/xmark.svg" alt="" />
        </div>
        <hr />
        <div class="mt-3 testconfig-card-name">
          <span class="cj-breakword"
            >Are you sure you want to select the '{{ tempConfig.configName }}'
            configuration ?</span
          >
        </div>

        <div class="d-flex align-items-center justify-content-end mt-3">
          <b-button class="addbtn mr-2" @click="saveConfiguration"
            >Select</b-button
          >
          <div class="cancelbtntext pointer" @click="clearConfig">Cancel</div>
        </div>
      </b-modal>
      <b-modal
        id="expired-config"
        centered
        hide-footer
        hide-header
        class="qb-add-ques-modal"
        v-model="showExpiredModal"
        @hidden="showExpiredModal = false"
      >
        <div class="d-flex align-items-center justify-content-between">
          <div class="modal-heading mt-3 px-2">
            You are selecting an expired Configuration
          </div>
          <div @click="showExpiredModal = false" class="xmark-modal-pos-1">
            <img src="../../../assets/panelist/blue_cross.svg" alt="" />
          </div>
        </div>

        <div class="px-2">
          <span class="note-text-modal">
            You have to edit the start and end date of the configuration to
            continue the selection
          </span>
        </div>

        <div class="d-flex justify-content-end mt-3 pt-2">
          <div class="mr-3 cancelpan-btn">
            <b-button style="width: 87px; height: 32px" @click="clearConfig"
              >Cancel</b-button
            >
          </div>
          <div class="addpanel">
            <b-button
              style="width: 87px; height: 32px"
              class="pl-3 pr-3"
              @click="editExpiredConfig"
            >
              Edit
            </b-button>
          </div>
        </div>
      </b-modal>
    </b-overlay>

    <TestConfig
      :showModal="showEditModal"
      :configType="configType"
      :configData="editableConfig"
      :isExpireEdit="isExpireEdit"
      @close-modal="closeEditModal"
      @config-created="handleNewConfig"
    />
  </b-modal>
</template>
<script>
import TestConfig from "./TestConfig.vue";
import { getConfigPage } from "../../../utils/apiFunctions.js";
import { closeConfigModal, gotopgnum, convertTime } from "../helpers";
import { NumbersOnly } from "../../Candidate/helpers.js";
import SelectDropdown from "../../../components/fixedcomponents/Select.vue";
import PageInput from "../../../components/InputComponents/PaginationInput.vue";
export default {
  name: "ViewConfig",
  props: {
    showModal: Boolean,
    configID: String,
    currentRoundData: Object,
    testConfigData: Object,
    jobDetail: Object,
    selectedIPIndex: null,
    context: Object,
  },
  components: {
    TestConfig,
    SelectDropdown,
    PageInput,
  },
  data() {
    return {
      isExpireEdit: false,
      selectedConfig: null,
      showExpiredModal: false,
      showEditModal: false,
      configType: "edit",
      editableConfig: null,

      sortByOrder: false,
      enableConfigFilter: false,
      filtercount: 0,
      selectexpconfig: false,
      showSpinner: false,
      configCount: 50,
      filterColumnConfig: "createdAt",
      searchConfig: "",
      showFilterBox: false,
      currentPage: 1,
      goToPage: null,
      total: null,
      pageStart: null,
      testoptions: [
        {
          value: "all",
          text: "All",
        },
        {
          value: "public",
          text: "Public",
        },
        {
          value: "private",
          text: "Private",
        },
      ],
      pageEnd: null,
      tempConfig: {},
      selectedConfiguration: {
        configID: "",
        config: {},
      },
      selectOptions: {
        text: "",
        value: "",
      },
      configurations: [],
      selectedRow: {},
    };
  },
  computed: {
    iscontainsNumber() {
      return !/^[1-9]\d*$/.test(this.goToPage);
    },
  },
  methods: {
    async handleNewConfig(configID) {
      try {
        await this.getAllConfigs(configID);
        this.$emit("select-config", this.selectedConfiguration);
        this.configAssign(this.selectedConfiguration);
      } catch (error) {
        console.error(error);
      }
    },
    createNewConfig() {
      this.configType = "add";
      this.editableConfig = {
        config: {},
      };
      this.populateRoundData();
      this.showEditModal = true;
    },
    closeEditModal() {
      this.getAllConfigs();
      this.showEditModal = false;
    },
    hidefilterbox() {
      this.showFilterBox = false;
    },
    closeViewConfig() {
      this.clearfilter();
      this.sortByOrder = false;
      this.enableConfigFilter = false;
      this.filterColumnConfig = "createdAt";
      this.searchConfig = "";
      // if(this.selectedConfig){this.saveConfiguration()}
      this.$emit("close-modal");
    },
    async getAllConfigs(configID) {
      try {
        this.showSpinner = true;

        const tempID =
          configID !== null &&
          typeof configID === "string" &&
          configID !== this.searchConfig
            ? configID
            : this.configID;

        let payload = {
          page: this.currentPage - 1,
          count: this.configCount,
          sortBy: {
            column:
              this.filterColumnConfig == "test"
                ? "config.test"
                : this.filterColumnConfig,
            order: this.sortByOrder,
          },
          searchQuery: this.searchConfig,
          filters: {
            testType:
              this.selectOptions.value === "all"
                ? ""
                : this.selectOptions.value,
          },
          configID: tempID,
        };
        if (payload.filters.testType == null) {
          delete payload.filters;
        }
        if (!this.enableConfigFilter && !this.filterColumnConfig) {
          delete payload.sortBy;
        }
        const response = await getConfigPage(payload);
        if (response.status == 200) {
          this.configurations = response.data.data.data;
          this.selectedConfiguration = response.data.data.selectedConfig;
          this.selectedRow = { ...this.selectedConfiguration };
          this.total = response.data.data.total;
          this.pageStart = response.data.data.pageStart;
          this.pageEnd = response.data.data.pageEnd;
          this.totalPages = Math.ceil(
            parseInt(this.total) / parseInt(this.configCount)
          );
          if (this.selectedConfiguration) {
            this.configAssign(this.selectedConfiguration);
            this.saveConfiguration();
          }
          this.showSpinner = false;
          this.showFilterBox = false;
        }

        const element = document.getElementById("config");
        element.scrollTo({
          top: 0,
          behavior: "smooth",
        });

        this.goToPage = "";
      } catch (error) {
        console.error(error);
      }
    },
    updatePage(value) {
      this.configCount = value;
      this.currentPage = 1;
      this.getAllConfigs();
    },
    saveConfiguration() {
      this.$emit("select-config", this.selectedConfig, true);
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    closeConfigModal() {
      closeConfigModal(this);
    },
    clearfilter() {
      this.currentPage = 1;
      this.selectOptions.value = "";
      this.selectOptions.text = "";
      if (this.filtercount != 0) {
        this.getAllConfigs();
      }
      this.filtercount = 0;
    },
    viewConfig(config) {
      this.configType = "view";
      this.fillConfigData(config);
      this.populateRoundData(config);
      this.showEditModal = true;
    },
    selectDpd(value) {
      this.selectOptions.value = value;
    },
    filterByAsc(filterBy) {
      this.sortByOrder = true;
      this.enableConfigFilter = !this.enableConfigFilter;
      this.filterColumnConfig = filterBy;
      this.getAllConfigs();
    },
    filterByDesc(filterBy) {
      this.sortByOrder = false;
      this.enableConfigFilter = !this.enableConfigFilter;
      this.filterColumnConfig = filterBy;
      this.getAllConfigs();
    },
    gotopgnum(page) {
      this.currentPage = Math.min(Math.max(1, page), this.totalPages);
      this.goToPage = null;
      gotopgnum(this, page);
    },
    applyFilter() {
      this.filtermodalshow = false;
      this.filtercount = 1;
      this.currentPage = 1;
      this.getAllConfigs();
    },
    editExpiredConfig() {
      this.showExpiredModal = false;
      this.editConfig(this.selectedConfig);
      this.isExpireEdit = true;
    },
    editConfig(config) {
      this.configType = "edit";
      this.fillConfigData(config);
      this.populateRoundData(config);
      this.showEditModal = true;
    },
    fillConfigData(config) {
      this.editableConfig = config;
      const defaultValues = {
        testOrg: "",
        testDesc: "",
        testInst: "",
        timebnsel: "",
        timebnvalue: "",
        dispDuration: false,
        dispCount: false,
        allowCandidateRemarks: false,
        quesPerScreen: "10",
        priority: "first",
        shuffle: false,
        dispReqStatus: false,
        displayReqFirst: false,
        dispMarks: false,
        test: "public",
        allowAgent: false,
        allowImageAndIdCapture: false,
        allowExtension: false,
        enableScreenShare: false,
        negativeMarkValue: null,
        openTestdt: null,
        closeTestdt: null,
        passingPercentage: null,
        testDuration: "30",
        typingTest: false,
        enableProctoring: false,
        communicationTest: false,
        communicationTestDuration: 45,
        communicationTestAttempts: null,
        typingDuration: 60,
        includeTimeNotifics: false,
        enableCamera: false,
        includeEndTest: false,
        instantemail: false,
        internetCheck: false,
        maxnoattempts: 1,
        buffertime: null,
        timebetweenattempts: null,
        screenCapture: null,
        dosAndDonts: [{ value: "", code: "" }],
      };
      this.editableConfig.config = Object.keys(defaultValues).reduce(
        (acc, key) => {
          acc[key] = config.config?.[key] ?? defaultValues[key];
          return acc;
        },
        {}
      );
    },
    populateRoundData(config) {
      const { openTestdt, closeTestdt, duration, passingPercentage } =
        this.currentRoundData;
      let tempConfig = {};
      let value = config ? config.open == "True" : true;
      if (openTestdt && value) {
        tempConfig.openTestdt = openTestdt;
      } else if (this.editableConfig.config.openTestdt) {
        tempConfig.openTestdt = convertTime(
          this.editableConfig.config.openTestdt,
          "india"
        );
      }
      if (closeTestdt && value) {
        tempConfig.closeTestdt = closeTestdt;
      } else if (this.editableConfig.config.closeTestdt) {
        tempConfig.closeTestdt = convertTime(
          this.editableConfig.config.closeTestdt,
          "india"
        );
      }
      if (duration) {
        tempConfig.testDuration = duration;
      }
      if (passingPercentage) {
        tempConfig.passingPercentage = passingPercentage;
      }
      this.editableConfig.config = {
        ...this.editableConfig.config,
        ...tempConfig,
      };
    },
    selectConfig() {
      if (this.selectedConfig.open === "False") {
        this.showExpiredModal = true;
      } else {
        this.$emit("select-config", this.selectedConfig);
      }
    },
    configAssign(config) {
      this.selectedConfig = { ...config };
    },
    clearConfig() {
      this.selectedConfig = null;
      this.showExpiredModal = false;
    },
    isSelected(config) {
      return this.selectedRow && this.selectedRow.configID === config.configID;
    },
  },
};
</script>
<style>
.qb-filter-count-config {
  width: 15px;
  background: #ff7e47;
  border-radius: 10px;
  height: 15px;
  font-weight: var(--weight-B);
  font-size: var(--size-10);
  padding-top: 2px;
  padding-left: 7px;
  position: absolute;
  top: -5px;
  right: 25px;
}
.xMarkCancelOut {
  position: absolute;
  top: -26px;
  right: -26px;
  border-radius: 50px;
  height: 20px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #72738e;
  cursor: pointer;
}

.group-filter-modal-selected {
  position: absolute;
  width: 300px;
  top: 33px;
  right: 6px;
  box-shadow: 0px 6px 10px rgb(0 0 0 / 25%);
  border-radius: 5px;
  z-index: 6;
  background: #f9f9f9;
  border: 1px solid rgba(41, 136, 230, 0.22);
  border-radius: 4px;
  padding: 15px;
}

.group-filter-modal {
  position: absolute;
  width: 300px;
  top: 33px;
  right: 6px;
  box-shadow: 0px 6px 10px rgb(0 0 0 / 25%);
  border-radius: 5px;
  z-index: 6;
  background: #f9f9f9;
  border: 1px solid rgba(41, 136, 230, 0.22);
  border-radius: 4px;
  padding: 15px;
}
.gridgreencolorDynamic-user {
  position: absolute;
  border-radius: 2px 1px 1px 2px;
  width: 4px;
  height: 90%;
  margin: auto;
  background: #20639b;
  top: 2px;
  left: 3px;
}
.disableDeleteIcon {
  opacity: 0.6;
  cursor: initial;
}
.img-h {
  height: 13px;
  width: 10px;
}
</style>
